import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { EarningDetail } from '@/modules/wealth/components/EarningDetail';
import { RedeemDetail } from '@/modules/wealth/components/RedeemDetail';
import { StrategyDetail } from '@/modules/wealth/components/StrategyDetail';
import { MinimumDepositDetail } from '@/modules/wealth/components/MinimumDepositDetail';
import { TransactionDetail } from '@/modules/wealth/components/TransactionDetail';
import { MandateDetail } from '@/modules/wealth/components/MandateDetail';
import { CostDetail } from '@/modules/wealth/components/CostDetail';
import { Modal } from '@warrenbrasil/nebraska-web';
import { DetailType } from '@/modules/wealth/types';
import MinimumRedemptionDetail from '@/modules/wealth/components/MinimumRedemptionDetail/MinimumRedemptionDetail.vue';

interface Props {
  isOpen: boolean;
  title: string;
  detailType: string;
  detailProps: Object;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailModal',
  props: {
    isOpen: { type: Boolean, default: false },
    title: null,
    detailType: null,
    detailProps: null
  },
  setup(__props: any) {

const props = __props as { isOpen: boolean, title: string, detailType: string, detailProps: Object };

const components = new Map<string, Vue.Component>([
  [DetailType.Transaction, TransactionDetail],
  [DetailType.Earning, EarningDetail],
  [DetailType.Redeem, RedeemDetail],
  [DetailType.MinimumDeposit, MinimumDepositDetail],
  [DetailType.MinimumRedemption, MinimumRedemptionDetail],
  [DetailType.Strategy, StrategyDetail],
  [DetailType.Mandate, MandateDetail],
  [DetailType.Cost, CostDetail]
]);



const getComponent = computed(() => components.get(props.detailType));
const testId = computed(() => `${props.detailType}-modal`);

return { __sfc: true,components, props, getComponent, testId, Modal }
}

})